import { Component, input } from '@angular/core';
import { SummaryItem } from '../../../models';

@Component({
  selector: 'app-report-value-pairs',
  templateUrl: './report-value-pairs.component.html',
  styleUrl: './report-value-pairs.component.scss',
})
export class ReportValuePairsComponent {
  public readonly summaryItems = input<SummaryItem[]>();
  public readonly cssClass = input<string>();
  public readonly labelMinWidth = input(true);
}
